import { data } from 'services';
import { getDateTime, getShortRFID } from 'services/types';
import { ParkingCell, ZonesIcons } from 'libs/ui';

export const getTableParams = (t, isPlate) => {
  // get row class
  const getRowClass = (row) => {
    let out = '';
    if (row.unauthorized || row.data?.unauthorized || row.is_suspicious) {
      out += ' is_suspicious';
    }
    return out;
  };

  /**
   * get zone/rack name
   * @param {*} nodeId
   * @param {*} rackId
   * @returns
   */
  const getRack = (row) => {
    const { node_id, rack_id } = row;
    const getDecorateName = (type, id) => {
      if (id) {
        const prefix = type === 'node' ? 'У' : 'C';
        return `${prefix}${id < 10 ? `0${id}` : id}`;
      }
      return '-';
    };
    const node = getDecorateName('node', node_id);
    const rack = getDecorateName('rack', rack_id);
    return `${node} ${rack}`;
  };

  // get fields
  const getFields = () => {
    const fields = [
      { name: 'timestamp', title: t('grid.Дата и время'), width: 210, sortField: 'timestamp', render: (val) => getDateTime(val) },
      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 135, sortField: 'vehicle_plate', clip: true },
      {
        name: 'mean_is_blocked',
        title: t('dict_filter.Список'),
        width: 75,
        render: (val) => data.getDictValue('passage.list', val),
        isHidden: !isPlate,
      },
      {
        name: 'type',
        title: t('dict_filter.Тип'),
        width: 75,
        render: (val) => data.getDictValue('passage.type', val),
        clip: true,
      },
      {
        name: 'result',
        title: t('dict_filter.Результат'),
        width: 100,
        render: (val) => data.getDictValue('passage.result', val),
        clip: true,
      },
      {
        name: 'zone_from',
        title: t('grid.Зона из'),
        width: 62,
        render: (val) => <ZonesIcons stayZones={val ? [val] : null} />,
      },
      {
        name: 'rack_id',
        title: t('grid.Узел/стойка'),
        width: 95,
        render: (_val, _, row) => getRack(row),
      },
      {
        name: 'zone_to',
        title: t('grid.Зона в'),
        width: 62,
        render: (val) => <ZonesIcons stayZones={val ? [val] : null} />,
      },
      { name: 'vehicle_class', title: t('dict_filter.Класс ТС'), width: 70, sortField: 'vehicle_class' },
      {
        name: 'mean_type',
        title: t('dict_filter.Тип СО'),
        width: 150,
        render: (val) => data.getDictValue('payment_mean_type', val),
        clip: true,
        isHidden: isPlate,
      },
      {
        name: 'mean_number',
        title: t('grid.Номер СО'),
        width: 150,
        render: (val, __other, row) => (row.mean_type === 'rfid' ? getShortRFID(val) : val),
        clip: true,
      },

      { name: 'csc_owner', title: t('form.Держатель'), sortField: 'csc_owner', width: 135 },
      { name: 'client_name', title: t('form.Клиент'), sortField: 'client_name', width: 135, isHidden: isPlate },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: '140px',
      });
    }

    return fields;
  };

  return { getFields, getRowClass };
};
